import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
import type {
  IconColor,
  IconName,
  IconSize,
} from '@mylighthouse/prism-ember/types/components/prism/icon';

interface GeneralIconWithTooltipSignature {
  Args: {
    color?: IconColor;
    iconName?: IconName;
    // TODO-TS: use Prism::Tooltip types when available
    side?: 'top' | 'bottom' | 'left' | 'right';
    size?: IconSize;
    slot?: string;
    tooltipContent: string;
    tooltipTitle?: string;
  };
}

const GeneralIconWithTooltip = <template>
  <div data-test-id="icon-with-tooltip" slot={{if @slot @slot}}>
    <PrismIcon
      @color={{@color}}
      @name={{if @iconName @iconName "circle-information-outline"}}
      @size={{if @size @size "extra-small"}}
      data-test-id="icon-with-tooltip-icon"
    />
    <PrismTooltip
      @side={{if @side @side "top"}}
      @text={{@tooltipContent}}
      @title={{@tooltipTitle}}
    />
  </div>
</template> satisfies TOC<GeneralIconWithTooltipSignature>;

export default GeneralIconWithTooltip;
